(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportPhotoDeleteController',PatchReportPhotoDeleteController);

    PatchReportPhotoDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatchReportPhoto'];

    function PatchReportPhotoDeleteController($uibModalInstance, entity, PatchReportPhoto) {
        var vm = this;
        vm.patchReportPhoto = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            PatchReportPhoto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
